<template>
  <h1>
    <router-link to="/ticket-survey-2019">{{ text }}</router-link>
  </h1>
</template>

<script>
export default {
  name: 'PageTitle',
  props: ['text']
}
</script>

<style scoped>

</style>
